export const useLinkTracker = () => {
    const getCurrentDuration = (timeOfMount) => {
        return new Date() - timeOfMount;
    };

    const generateOnClick = (url, trackerKey, accessId, onUpdateRecord, timeOfMount) => async () => {
        await onUpdateRecord(accessId, {[trackerKey]: getCurrentDuration(timeOfMount)});
        window.location.href = url;
    };
    return {
        generateOnClick,
    };
};